import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import React from "react";
import { makeStyles } from "tss-react/mui";
import ReadOnlyProtectedIconButton from "../../Inputs/ReadOnlyProtectedIconButton";

const useStyles = makeStyles()((theme) => ({
  icon: {
    padding: theme.spacing(1),
  },
  iconSelected: {
    boxShadow: "inset 0 0 8px rgba(0,0,0,0.5)",
  },
}));

const SideBarIconButton: React.FC<{
  children: React.ReactNode;
  tooltipText: string;
  tooltipPlacement?: "left" | "bottom";
  isSelected?: boolean;
  disabled?: boolean;
  isPinProtected?: boolean;
  color?: "primary" | "secondary" | "default" | "success";
  dataTestId?: string;
  onClick: (() => void) | ((event: React.MouseEvent<HTMLButtonElement>) => void);
  hide?: boolean;
}> = ({
  children,
  tooltipText,
  isSelected = false,
  disabled = false,
  isPinProtected = true,
  color = "default",
  tooltipPlacement = "left",
  dataTestId,
  onClick,
  hide,
}) => {
  const { classes, cx } = useStyles();

  if (hide === true) {
    return null;
  }

  return (
    <Tooltip title={tooltipText} placement={tooltipPlacement}>
      <div
        className={cx(classes.icon, {
          [classes.iconSelected]: isSelected,
        })}
      >
        {isPinProtected && (
          <ReadOnlyProtectedIconButton onClick={onClick} disabled={disabled} color={color} data-testid={dataTestId}>
            {children}
          </ReadOnlyProtectedIconButton>
        )}
        {!isPinProtected && (
          <IconButton onClick={onClick} disabled={disabled} color={color} data-testid={dataTestId}>
            {children}
          </IconButton>
        )}
      </div>
    </Tooltip>
  );
};

export default SideBarIconButton;
